import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TogglesResponse} from './types/toggles-response';

@Injectable({
  providedIn: 'root'
})
export class TogglesService {
  private readonly BASE_URL = '/sag/toggles/';

  constructor(private http: HttpClient) {
  }

  pobierzToggles(): Observable<TogglesResponse> {
    return this.http.get<TogglesResponse>(this.releaseUrl())
  }

  private releaseUrl(): string {
    return this.createInitUrl('release');
  }

  private createInitUrl(param: String): string {
    return `/sag/toggles/${param}`
  }

}
